module.exports = __webpack_public_path__ + "static/02-157b47a717b741c50a3403620bea4c3c.jpg";